import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

export function useGetPaymentProfileId() {
  const { deusExMachina } = useDeusExMachina()
  const paymentProfileId = deusExMachina?.entity?.stoneAccount?.paymentProfiles?.[0]?.id

  return {
    paymentProfileId
  }
}
